import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { EnvironmentService } from './environment.service';
import { Observable } from '../../../../node_modules/rxjs';

@Injectable()
export class StoreService {

  private storeId: string;
  constructor(
    private httpService: HttpService,
    private envService: EnvironmentService
  ) {
    this.storeId = this.envService.getStore('storeId');
  }

  public getFeatures(): Observable<any> {
    const url = 'stores/' + this.storeId + '/features';
    // const url = 'http://apicloud-x.getsandbox.com/storeFeatures';
    const payload = {};
    return this.httpService.get(url, payload);
  }

}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/services/store.service.ts